module.exports = __webpack_public_path__ + "img/automati2.6599772f.jpg";